module.exports = __webpack_public_path__ + "static/media/Medcare Hospital Al Safa.b4d11bba.jpg";